import { render, staticRenderFns } from "./valDetail.vue?vue&type=template&id=7e2a58c5&scoped=true&"
import script from "./valDetail.vue?vue&type=script&lang=js&"
export * from "./valDetail.vue?vue&type=script&lang=js&"
import style0 from "./valDetail.vue?vue&type=style&index=0&id=7e2a58c5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2a58c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e2a58c5')) {
      api.createRecord('7e2a58c5', component.options)
    } else {
      api.reload('7e2a58c5', component.options)
    }
    module.hot.accept("./valDetail.vue?vue&type=template&id=7e2a58c5&scoped=true&", function () {
      api.rerender('7e2a58c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/comm/valManage/valDetail.vue"
export default component.exports